// @refresh reset

// App component - routing is now handled by data router in AppProviders
import { AppProviders } from './AppProviders'

export const App = () => {
  return <AppProviders />
}
